import { render, staticRenderFns } from "./input-invoice-scan.vue?vue&type=template&id=453cf64d"
import script from "./input-invoice-scan.vue?vue&type=script&setup=true&lang=js"
export * from "./input-invoice-scan.vue?vue&type=script&setup=true&lang=js"
import style0 from "./input-invoice-scan.vue?vue&type=style&index=0&id=453cf64d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports